export default __webpack_public_path__ + "ab814719ecc95ac43f5a5e2e1f673f7d.png";